import * as core from '../../../../../../../core'

import { query } from './save-award.query'

export const RESOURCE = {
  payload: {
    alias: 'sr.actions.save-award',
    description: 'Save Award',
    name: 'Save Award',
    query,
  },
  type: core.quiver.Resource.Type.MosaicAction,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicAction>
